import { Divider, Stack, Typography } from '@mui/material';
import { IFamilyMembers } from 'API/personalDetails';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { AccordionUserDetails } from '../AccordionDetails';
import { ChildrenInfo } from './ChildrenInfo';
import { PartnerInfo } from './PartnerInfo';
import { useDictionary } from 'Hooks';
import { NavigateTo } from '../GeneralAccordion/NavigateTo';

interface IFamilyStatusAccordion {
  title: string;
  userFamily: IFamilyMembers[];
  status: string;
}

export const FamilyStatusAccordion = ({
  title,
  userFamily,
  status,
}: IFamilyStatusAccordion) => {
  const partner = userFamily.filter((familyMember: any) => {
    return familyMember.relation === 2;
  });
  const children = userFamily.filter((familyMember: any) => {
    return familyMember.relation === 1;
  });

  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  return (
    <AccordionUserDetails title={title}>
      <Divider
        aria-hidden={'true'}
        orientation={'horizontal'}
        sx={{ borderColor: 'primary.shade_100', margin: '16px 0' }}
      />
      <Stack gap={'24px'}>
        <Stack gap={'8px'}>
          <Typography variant='body6' component='h3'>
            {dictionary.personalStatus}
          </Typography>
          <Typography variant='body5'>{status}</Typography>
        </Stack>
        <Stack gap={'20px'}>
          {partner.length > 0 && (
            <>
              <Divider
                aria-hidden={'true'}
                orientation={'horizontal'}
                sx={{ borderColor: 'primary.shade_100' }}
              />
              <PartnerInfo
                title={dictionary.familyStatus.partnerInformation}
                partner={partner[0]}
              />
            </>
          )}
          {partner.length > 0 && children.length > 0 && (
            <Divider
              aria-hidden='true'
              orientation={'horizontal'}
              sx={{ borderColor: 'primary.shade_100' }}
            />
          )}
          {children.length > 0 && (
            <ChildrenInfo
              title={dictionary.familyStatus.childrenInformation}
              children={children}
            />
          )}
        </Stack>
        <NavigateTo
          href='/requests/update-personal-details/8/18/2'
          label={dictionary.links.updateFamilyStatus}
        />
      </Stack>
    </AccordionUserDetails>
  );
};
